<span [innerHTML]="($safeNavigationMigration(log?.details?.translationCode) | translate : { targetName: $safeNavigationMigration(log?.details?.targetName) | escapeHtml }) | anchorWrap : $safeNavigationMigration(log?.details?.targetName) : $safeNavigationMigration(log?.details?.targetId) : 'Digital Supervision'"></span>
@if (!log?.staffId && log?.staffName === 'Everon Admin') {
  <span [innerHTML]="('BY_USER' | translate : { targetString: 'Everon Admin' }) | strongWrap : 'Everon Admin'"></span>
} @else {
  <span [innerHTML]="('BY_USER' | translate : { targetString: ($safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId)) | escapeHtml }) | anchorWrap : ($safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId)) : $safeNavigationMigration(log?.staffId) : 'Staff' : '' : true"></span>
}
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />

@if (log?.details?.translationCode !== 'SCHEDULED_PAUSE_CREATED') {
  <span class="subtitle">{{ "MODIFICATIONS" | translate | uppercase }}</span>
}
<div class="item-group-box">
  <div class="container">
    @if (pauseChanges?.pauseStart) {
      <span class="item-title">{{ "PAUSE_TIME" | translate }}:</span>
      @if (log?.details?.translationCode !== 'SCHEDULED_PAUSE_CREATED') {
        <div class="item-pair-value">
          <span class="negative-highlight line-through">
            {{ $safeNavigationMigration(pauseChanges.pauseStart.oldValue) | moment : "l LT" }}
          </span>
          <i class="fa-light fa-arrow-right-long fa-lg"></i>
          <span class="positive-highlight">
            {{ $safeNavigationMigration(pauseChanges.pauseStart.newValue) | moment : "l LT" }}
          </span>
        </div>
      } @else {
        <div class="item-value">
          <span class="positive-highlight">
            {{ $safeNavigationMigration(pauseChanges.pauseStart.newValue) | moment : "l LT" }}
          </span>
        </div>
      }
    }
    @if (pauseChanges?.pauseEnd) {
      <span class="item-title">{{ "RESUME_AT" | translate }}:</span>
      @if (log?.details?.translationCode !== 'SCHEDULED_PAUSE_CREATED') {
        <div class="item-pair-value">
          <span class="negative-highlight line-through">
            {{ $safeNavigationMigration(pauseChanges.pauseEnd.oldValue) | moment : "l LT" }}
          </span>
          <i class="fa-light fa-arrow-right-long fa-lg"></i>
          <span class="positive-highlight">
            {{ $safeNavigationMigration(pauseChanges.pauseEnd.newValue) | moment : "l LT" }}
          </span>
        </div>
      } @else {
        <div class="item-value">
          <span class="positive-highlight">
            {{ $safeNavigationMigration(pauseChanges.pauseEnd.newValue) | moment : "l LT" }}
          </span>
        </div>
      }
    }
  </div>
</div>
